import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { TC_CHECK_CIRCLE_SVG } from "../../utils/tc_svgs";
import { SelectOption } from "../RequiredDocDropDown";
import { AppBottomSheet } from "./AppBottomSheet";
import { AppButton } from "./AppButton";
import { AppIcon } from "./AppIcon";
import { AppList, AppListItem } from "./AppList";
import { AppOverlay } from "./AppOverlay";

interface SelectBottomSheetProps {
  options: SelectOption[];
  selectedOption: SelectOption | null;
  isOpen: boolean;
  onChoose: (option: SelectOption) => void;
  onCancel: () => void;
}

const SelectBottomSheet = (props: SelectBottomSheetProps) => {
  const checkedOptionIcon = (
    <AppIcon icon={TC_CHECK_CIRCLE_SVG} fill="var(--success-color)" stroke="var(--success-color)" />
  );

  return (
    <AppOverlay>
      <AppBottomSheet
        isOpen={props.isOpen}
        onRequestClose={props.onCancel}
        title={translate(STRINGS.PLEASE_SELECT_AN_OPTION)}
        rounded={true}
      >
        <AppList bordered={true}>
          {props.options.map((option) => {
            let isSelected = false;
            if (props.selectedOption !== null && option.key === props.selectedOption.key) {
              isSelected = true;
            }
            return (
              <AppListItem
                key={option.key}
                title={option.value.toString()}
                trailing={isSelected ? checkedOptionIcon : null}
                onClick={() => props.onChoose.call(null, option)}
              />
            );
          })}
        </AppList>
        <AppButton
          variant="outline"
          className="SelectBottomSheet__cancel"
          size="small"
          onClick={props.onCancel}
        >
          {translate(STRINGS.CANCEL)}
        </AppButton>
      </AppBottomSheet>
    </AppOverlay>
  );
};

export default React.memo(SelectBottomSheet);
